import Vue from 'vue'
import { TLDService} from '@/common/api.service'

import {
    FETCH_TLDS,
} from './actions.type'

import {
    SET_TLDS,
} from './mutations.type'

const initialState = {
    tlds: []
}

export const state = Object.assign({}, initialState)

export const actions = {
    [FETCH_TLDS] (context) {
        return TLDService.get()
        .then(({ data }) => {
            context.commit(SET_TLDS, data)
        })
    }, 
}

export const mutations = {
    [SET_TLDS] (state, tlds) {
        state.tlds = tlds
    },
}

const getters = {
    tlds (state) {
      return state.tlds
    },
  }

export default {
    state,
    actions,
    mutations,
    getters
}